 

class ApplicantProfileDirective implements ng.IDirective {
        restrict = 'AE'
        controller = ApplicantProfileController
        controllerAs = 'acCtrl'
        bindToController = true
        templateUrl = 'controls/ApplicantProfile/applicationProfile.html'    
        scope = {
            applicationId: '='
        }               
}

class ApplicantProfileController {
    applicationId: number
    applicationProfile: any;

    observers;

    static $inject = ['$scope', 'ApplicantProfile', 'Auth', 'dialogs', 'PushHub'];
    constructor(private $scope, private ApplicantProfile, private Auth, private dialogs, PushHub) {

        $scope.$on('changeApplicationStatus', (event, onHoldStatus) => {
            this.refresh();
        });
        $scope.$on('push:applicaionStatusChange', (event, onHoldStatus) => {
            this.refresh();
        });

        if (Auth.user.isOfficer) {
            PushHub.getApplicationObservers().then(p => {
                this.observers = p;
                $scope.$digest();
            });
        }
    }

    $onInit() {
        this.refresh();
    }

    private refresh() {
        this.ApplicantProfile.query({
            applicationId: this.applicationId
        }, (result) => {
            this.applicationProfile = result;
        });
    }
}


angular
    .module('app')
    .directive('applicantProfile', () => new ApplicantProfileDirective());
